// src/redux/actions/vehicleActions.js

export const DELETE_VEHICLE = 'DELETE_VEHICLE';

// Action to delete vehicle by key
export const deleteVehicle = (key) => {
    return {
        type: DELETE_VEHICLE,
        payload: key
    };
};
